const styleBreadCrumb = () => {
    document.addEventListener("DOMContentLoaded", function () {
        $('.bread-crumb-container').addClass('bread-crumb-container-context');
        $('.site-width').hide();
    });
};

export {
    styleBreadCrumb
};
